import React, {Component} from 'react';
import { connect } from 'dva';
import BaseComponent from '../../../components/BaseComponent';
import Dimio, {DimioNotice} from '../../../components/Dimio';
import TemplateTravel01 from '../templates/TemplateTravel01';

class LoadAd extends BaseComponent {
  constructor(props) {
    super(props);

    this.state = {
      data: false
    }
  }

  componentWillMount() {
//    console.info(this.props);
    const {api, id, template, type} = this.props;
    this.showLoading();

    const self = this;

    if(api) {
      this.load(api, {
        query: {id: id},
        onSuccess(res){
          console.info(type+': '+api+'/'+id, res.data);
          self.hideLoading();
          self.setState({data: res.data});
        }
      });
    }
  }

  render(){
    const {id, template, type, ad} = this.props;
    const {data} = this.state;

    return(
      <div style={{position:'relative'}}>
        <DimioNotice {...ad} />
        {data &&
        <div>
          {template === '01' &&
          <TemplateTravel01 data={this.state.data} />
          }
        </div>
        }
      </div>
    )
  }
}

export default connect(({ ad }) => ({
  ad
}))(LoadAd);


// WEBPACK FOOTER //
// ./src/pages/ad/components/LoadAd.js